export default {
  WUWOW: 1,
  WUWOW_JUNIOR: 2,
};
